import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { DeviceDetectorModule } from 'ngx-device-detector';

// services
import { GetService } from './dataservice/get.service';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { WebShareComponent } from './web-share/web-share.component';
import { ClinicalComponent } from './web-share/clinical/clinical.component';
import { EventComponent } from './web-share/event/event.component';
import { CmeComponent } from './web-share/cme/cme.component';
import { ChannelComponent } from './web-share/channel/channel.component';
import { DoctalkComponent } from './web-share/doctalk/doctalk.component';
import { SessionComponent } from './web-share/session/session.component';
import { SurveyComponent } from './web-share/survey/survey.component';
import { WebinarComponent } from './web-share/webinar/webinar.component';
import { PharmaComponent } from './web-share/pharma/pharma.component';
import { FeedComponent } from './web-share/feed/feed.component';
import { ProfileComponent } from './web-share/profile/profile.component';
import { ModalComponent } from './web-share/modal/modal.component';
import { GaDirective } from './directive/ga.directive';
import { DrugComponent } from './web-share/drug/drug.component';
import { DoctalkSeriesComponent } from './web-share/doctalk-series/doctalk-series.component';
import { MeetingComponent } from './web-share/meeting/meeting.component';




// import { NgbdDropdownBasic } from './dropdown-basic';


@NgModule({
  declarations: [
    AppComponent,
    WebShareComponent,
    ClinicalComponent,
    EventComponent,
    CmeComponent,
    ChannelComponent,
    DoctalkComponent,
    SessionComponent,
    SurveyComponent,
    WebinarComponent,
    PharmaComponent,
    FeedComponent,
    ProfileComponent,
    ModalComponent,
    GaDirective,
    DrugComponent,
    DoctalkSeriesComponent,
    MeetingComponent
  ],
  imports: [

    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ModalModule.forRoot(),
    DeviceDetectorModule.forRoot()
  ],
  providers: [GetService],
  bootstrap: [AppComponent]
})
export class AppModule { }
